import type { FlatNode } from "screens/call/callscript-graph-to-nested";
import CheckIcon from "assets/annotation-check.svg?react";
import AlertIcon from "assets/alert-triangle.svg?react";
import FileIcon from "assets/file-check.svg?react";
import ClockIcon from "assets/clock-stopwatch.svg?react";

import styles from "./index.module.css";
import formatDuration from "utils/format-duration";
import clsx from "clsx";

type CallCompletionOverlayProps = {
  totalScore: number;
  missedCompliance: FlatNode[];
  triggeredCount: number;
  callDuration: number;
  isListenerMode: boolean;
};

export const CallSummary = ({
  totalScore,
  missedCompliance,
  triggeredCount,
  callDuration,
  isListenerMode,
}: CallCompletionOverlayProps) => {
  return (
    <div className={styles.card}>
      <h3>Call Summary</h3>
      <div className={styles.summaryDetails}>
        {!isListenerMode && (
          <div className={styles.detail}>
            <div className={styles.img}>
              <CheckIcon />
            </div>
            <p className={styles.text}>Score:</p>
            <div
              className={styles.stat}
              data-color={totalScore >= 75 ? "success" : totalScore >= 50 ? "warning" : "error"}
            >
              {totalScore}%
            </div>
          </div>
        )}
        <div className={styles.detail}>
          <div className={styles.img}>
            <AlertIcon />
          </div>
          <p className={styles.text}>Cues:</p>
          <div className={styles.stat}>{triggeredCount}</div>
        </div>
        <div className={styles.detail}>
          <div className={styles.img}>
            <ClockIcon />
          </div>
          <p className={styles.text}>Time:</p>
          <div className={clsx(styles.stat, styles.time)}>{formatDuration(callDuration)}</div>
        </div>
        {!isListenerMode && (
          <div className={styles.detail}>
            <div className={styles.img}>
              <FileIcon />
            </div>
            <p className={styles.text}>Compliance Phrases Missed:</p>
            <div className={styles.stat}>{missedCompliance.length}</div>
          </div>
        )}
      </div>
    </div>
  );
};
